{
    "label": {
        "breadcrum": "Breadcrum",
        "datePicker": "Select date"
    },
    "button": {
        "navLogOff": "Log off",
        "previous": "Previous",
        "next": "Next"
    },
    "pagination": {
        "pageSize": "Page size",
        "numberOfPages": "Number of pages"
    },
    "image": {
        "emailSent": "Email has been sent."
    }
}